import api from './axios';

export const getStaff = () => api.get('/api/v1/staff');
export const addStaff = (data) => api.post('/api/v1/staff', data);
export const updateStaff = (id, data) => api.put(`/api/v1/staff/${id}`, data);
export const deleteStaff = (id) => api.delete(`/api/v1/staff/${id}`);

export const getPayrolls = () => api.get('/api/v1/payrolls');
export const runPayroll = (data) => api.post('/api/v1/payrolls', data);
export const updatePayroll = (id, data) => api.put(`/api/v1/payrolls/${id}`, data);
export const deletePayroll = (id) => api.delete(`/api/v1/payrolls/${id}`);
export const downloadPayslip = (id) => api.get(`/api/v1/payrolls/${id}/download`, { responseType: 'blob' });
export const sendPayslipEmail = (id) => api.post(`/api/v1/payrolls/${id}/email`);

const SalaryService = {
  getStaff,
  addStaff,
  updateStaff,
  deleteStaff,
  getPayrolls,
  runPayroll,
  updatePayroll,
  deletePayroll,
  downloadPayslip,
  sendPayslipEmail
};

export default SalaryService;
